export default __webpack_public_path__ + "static/media/1880.6a4299af.png";